import type { ValidationError } from '@/types/api'
import { publishErrorText } from '@/features/editor/lib/publishErrorText'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  Button,
} from '@teach/ui'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  open: boolean
  errors: ValidationError[]
  onClose: () => void
}

export const ValidationErrorsDialog = ({ open, errors, onClose }: Props) => {
  const m = useMessages(messages)
  return (
    <Dialog open={open} onOpenChange={(next) => (next ? undefined : onClose())}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>{m.notReadyTitle}</DialogTitle>
          <DialogDescription>{m.notReadyBody}</DialogDescription>
        </DialogHeader>
        <ul className="max-h-[60vh] space-y-2 overflow-y-auto">
          {errors.map((e) => {
            const { where, what, hint } = publishErrorText(e)
            return (
              <li key={`${e.location}|${e.message}`} className="text-sm">
                <span className="font-semibold">{where}:</span> {what}
                {hint ? <div className="text-xs text-muted-foreground">{hint}</div> : null}
              </li>
            )
          })}
        </ul>
        <DialogFooter>
          <Button onClick={onClose}>{m.close}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
